export default {
  me: null,
  anonProfile: false,
  orders: [],
};
